export default {
    'Number': '序号',
    'NoData': '暂无内容',
    'Cancel': '取消',
    'OK': '确定',
    'StartImport': '开始导入',
    'importWorkflowTips': '流程视图不可导入',
    'ImportData': '导入数据',
    'ReImport': '重新导入',
    'Skip': '跳过',
    'SureImport': '确定导入',
    'ExportFailure': '导出失败',
    'ExportLoading': '正在生成Excel表，请稍候...',
    'AllBeShown': '已展示全部内容',
    'DeleteItems': '以下数据删除后不能恢复，确定要删除吗？',
    'BizData': '业务数据',
    'wlData1': '未关联父子流程的流程数据',
    'wlData2': '已关联子流程的父流程数据',
    'wlData3': '子流程数据',
    'DeleteItems1': '（数据删除后，将同步删除已产生的流程实例）',
    'DeleteItems2': '（父流程删除后将同步删除与其绑定的子流程数据及实例）',
    'DeleteItems3': '（子流程删除后将同步删除实例及与父流程产生的映射关系）',
    'NotAllowedDelete': '普通用户不可删除非草稿流程数据',
    'NotDraftDelete': '流程草稿数据',
    'BusinessRuleException': '【{schemaName}】的【{businessRuleName}】业务规则的【{nodeName}】节点中使用的数据项【{propertyCode}】在系统中不存在，请联系管理员处理！',
    'LogicCheckException': '【{nodeName}】未在目标模型【{targetSchemaName}】中找到满足条件的校验数据',
    'Items': '条',
    'NoPermissionAdd': '您没有发起流程的权限',
    'NoPublish': '流程还未发布',
    'NoPermissionDelete': '您对这些数据没有删除权限',
    'DeleteItemsTips': '成功删除{successCount}条数据，有{errorCount}条数据没有删除权限',
    'DeleteFailed': '删除失败',
    'DeleteLoading': '删除中',
    'DeleteSuccess': '删除成功',
    'Query': '查询',
    'Add': '新增',
    'Reset': '重置',
    'More': '更多',
    'TakeUp': '收起',
    'NoSearchResult': '暂无搜索结果',
    'ContentLoadingFailed': '内容加载失败',
    'Refresh': '刷新',
    'Loading': '加载中',
    'ImportTips1': '为确保上传数据与列表内容匹配，请先',
    'ImportTips2': '下载示例文件',
    'ImportTips3': '支持.xlsx格式，文件大小不限',
    'ImportTips4': '导入数据过程中请不要关闭页面，避免导入错误',
    'ImportTips5': '系统异常，导入失败！请重新导入',
    'ImportTips6': '导入成功{num}条',
    'ImportTips7': '导入失败{num}条',
    'ImportTips8': '重新编辑后可再次导入',
    'ImportTips9': '您的数据已超过500条，请删除部分数据或分批重新上传',
    'ImportTips10': '当前文件内的列标题与此列表不一致，请参照',
    'ImportTips11': '只能上传一个文件',
    'ImportWarn': '不支持导入流程数据，导入前请仔细核对!',
    'ImportLocalFaile': '上传本地文件',
    'ClickToImport': '点击或拖拽上传',
    'DownloadFailed': '下载失败',
    'Importing': '导入中',
    'ImportSuccess': '导入成功',
    'ImportTestError': '列表数据重新导入时参数校验失败！',
    'ImportFailed': '导入失败',
    'DownloadFailedList': '下载失败列表',
    'SampleFile': '示例文件',
    'Recheck': '重新检查',
    'ChooseQueryFiled': '选择查询字段',
    'ChooseQueryFiledTips': '导入时会根据查询字段查询是否已有数据，如果存在已有数据，就覆盖导入，如果不存在就新增导入，只支持数据标题、单据号、短文本类数据项',
    'Total': '共{num}条',
    'Screen': '筛选',
    'SetDisplayItems': '展示项设置',
    'FormTrack': '表单留痕',
    'CopyLink': '复制链接',
    'recovery': '恢复默认设置',
    'chooseColumns': '请设置展示字段',
    'dragToSort': '长按可对字段进行拖拽排序',
    'checkAll': '全选',
    'printQrcode': '打印二维码',
    'totalTip': '当前共计{total}条数据；请在预览时扫描二维码检查打印数据是否正确',
    'chooseTagSize': '选择标签纸尺寸',
    'width': '宽',
    'height': '高',
    'qrcodeText': '二维码底部文字',
    'bizDataItem': '业务数据项',
    'sysDataItem': '系统数据项',
    'textNumber': '底部文字字号',
    'mostShowOne': '最多可展示一行内容',
    'example': '示例图',
    'qrcodeTextExample': '二维码底部文字示例',
    'preview': '预览',
    'print': '打印预览',
    'pleaseSelect': '请选择',
    'startExport': '开始导出',
    'exportData': '导出数据',
    'exportTips': '系统将导出勾选字段数据',
    'loading': '正在生成中，请稍等...',
    'importTitleTips': '请确认【选人控件名称】重复/空数据的值',
    'chooseUser': '选择人员',
    'chooseData': '请先选择数据！',
    'chooseSheetData': '请先选择当前子表数据！',
    'null': '空',
    'notData': '必填数据缺失',
    'dataRepeat': '重复',
    'dataNoExisted': '不存在',
    'dataDeptDisable': '部门禁用',
    'onlyDataDept': '只限单选',
    'repeat': '（重复）',
    'noExisted': '（不存在）',
    'deptDisable': '（部门禁用）',
    'onlyData': '（只限单选）',
    'loadMore': '查看更多数据',
    'loadCompleted': '已加载全部数据',
    'modifyOwner': '修改拥有者',
    'selectOwner': '选择拥有者',
    'ownerDepartment': '拥有者部门',
    'modifyExplain': '修改说明',
    'placeholder': '请输入',
    'pleaseSelectOwner': '请选择拥有者',
    'ownerTip': '您选择的数据中有{num}条数据您没有修改拥有者的权限，系统将不修改这{num}条数据的拥有者。',
    'modifySuccess': '修改成功',
    'printformTips': '您选中的数据已超过{size}条，请删除部分数据或分批重新打印',
    'isCustomizePrintTemp': '当前数据没有设置自定义打印模板或者未启用打印模板功能',
    'selectDataTips': '有{num}条错误下拉框',
    'radioDataTips': '有{num}条错误单选框',
    'checkboxDataTips': '有{num}条错误复选框',
    'importDataTips': '无法匹配，请输入相同的选项内容',
    'tips': '提示：',
    'gotIt': "知道了",
    'complete': "完成",
    'batchUpdata': '批量修改',
    'addResult': '新增结果',
    'filterCondition': '筛选条件',
    'importTitleBatchTips': '仅支持批量修正人员、部门',
    'all': "全部"
};
